(function () {
  var SIGNS = [
    { id: 'aries', name: 'Aries', symbol: '♈', dates: 'Mar 21 — Apr 19', planet: 'Mars',
      quote: 'The stars ignite your courage today. Take the first step — momentum follows bold intention.' },
    { id: 'taurus', name: 'Taurus', symbol: '♉', dates: 'Apr 20 — May 20', planet: 'Venus',
      quote: 'Steady beauty surrounds your path. Trust patience; what you build now will endure.' },
    { id: 'gemini', name: 'Gemini', symbol: '♊', dates: 'May 21 — Jun 20', planet: 'Mercury',
      quote: 'Words carry power today. Speak clearly, listen closely, and let curiosity guide you.' },
    { id: 'cancer', name: 'Cancer', symbol: '♋', dates: 'Jun 21 — Jul 22', planet: 'Moon',
      quote: 'Your intuition is a compass. Honor your feelings and protect what matters most.' },
    { id: 'leo', name: 'Leo', symbol: '♌', dates: 'Jul 23 — Aug 22', planet: 'Sun',
      quote: 'Your light is meant to be seen. Create boldly and lead with warmth and generosity.' },
    { id: 'virgo', name: 'Virgo', symbol: '♍', dates: 'Aug 23 — Sep 22', planet: 'Mercury',
      quote: 'Precision becomes your gift today. Small refinements unlock meaningful progress.' },
    { id: 'libra', name: 'Libra', symbol: '♎', dates: 'Sep 23 — Oct 22', planet: 'Venus',
      quote: 'Balance is within reach. Seek harmony in relationships and choose grace over haste.' },
    { id: 'scorpio', name: 'Scorpio', symbol: '♏', dates: 'Oct 23 — Nov 21', planet: 'Pluto',
      quote: 'Transformation calls from the depths. Release what no longer serves your truth.' },
    { id: 'sagittarius', name: 'Sagittarius', symbol: '♐', dates: 'Nov 22 — Dec 21', planet: 'Jupiter',
      quote: 'Horizons widen before you. Follow wonder, expand your vision, and trust the journey.' },
    { id: 'capricorn', name: 'Capricorn', symbol: '♑', dates: 'Dec 22 — Jan 19', planet: 'Saturn',
      quote: 'Discipline opens doors today. Commit to your goals and climb with quiet confidence.' },
    { id: 'aquarius', name: 'Aquarius', symbol: '♒', dates: 'Jan 20 — Feb 18', planet: 'Uranus',
      quote: 'The stars align to illuminate your path of innovation. Your unique perspective is your greatest strength.' },
    { id: 'pisces', name: 'Pisces', symbol: '♓', dates: 'Feb 19 — Mar 20', planet: 'Neptune',
      quote: 'Dreams and reality intertwine. Trust your imagination and let compassion lead.' }
  ];

  function hashSeed(str) {
    var h = 2166136261;
    for (var i = 0; i < str.length; i++) {
      h ^= str.charCodeAt(i);
      h = Math.imul(h, 16777619);
    }
    return h >>> 0;
  }

  function mulberry32(a) {
    return function () {
      a |= 0;
      a = (a + 0x6d2b79f5) | 0;
      var t = Math.imul(a ^ (a >>> 15), 1 | a);
      t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
  }

  function getZodiacByDate(date) {
    var m = date.getMonth() + 1;
    var d = date.getDate();
    if ((m === 12 && d >= 22) || (m === 1 && d <= 19)) return 'capricorn';
    if ((m === 1 && d >= 20) || (m === 2 && d <= 18)) return 'aquarius';
    if ((m === 2 && d >= 19) || (m === 3 && d <= 20)) return 'pisces';
    if ((m === 3 && d >= 21) || (m === 4 && d <= 19)) return 'aries';
    if ((m === 4 && d >= 20) || (m === 5 && d <= 20)) return 'taurus';
    if ((m === 5 && d >= 21) || (m === 6 && d <= 20)) return 'gemini';
    if ((m === 6 && d >= 21) || (m === 7 && d <= 22)) return 'cancer';
    if ((m === 7 && d >= 23) || (m === 8 && d <= 22)) return 'leo';
    if ((m === 8 && d >= 23) || (m === 9 && d <= 22)) return 'virgo';
    if ((m === 9 && d >= 23) || (m === 10 && d <= 22)) return 'libra';
    if ((m === 10 && d >= 23) || (m === 11 && d <= 21)) return 'scorpio';
    return 'sagittarius';
  }

  function renderDetail(sign, rng) {
    document.getElementById('astro-detail-name').textContent = sign.name;
    document.getElementById('astro-detail-dates').textContent = sign.dates;
    document.getElementById('astro-detail-quote').textContent = '"' + sign.quote + '"';
    document.getElementById('astro-lucky-energy').textContent = Math.floor(70 + rng() * 25) + '%';
    document.getElementById('astro-alignment').textContent = sign.planet;
  }

  function init() {
    document.body.classList.add('moyshop-horoscope-page');

    var grid = document.getElementById('astro-sign-grid');
    if (!grid) return;

    var today = new Date();
    var defaultId = getZodiacByDate(today);
    var selectedId = defaultId;

    function selectSign(id) {
      selectedId = id;
      var sign = SIGNS.filter(function (s) { return s.id === id; })[0];
      if (!sign) return;
      var rng = mulberry32(hashSeed(today.toDateString() + '-' + id));
      renderDetail(sign, rng);
      grid.querySelectorAll('.moyshop-astro__sign').forEach(function (btn) {
        btn.classList.toggle('is-active', btn.getAttribute('data-id') === id);
      });
    }

    SIGNS.forEach(function (sign) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'moyshop-astro__sign';
      btn.setAttribute('data-id', sign.id);
      btn.setAttribute('role', 'option');
      btn.innerHTML =
        '<span class="moyshop-astro__sign-circle">' + sign.symbol + '</span>' +
        '<span class="moyshop-astro__sign-label">' + sign.name + '</span>';
      btn.addEventListener('click', function () { selectSign(sign.id); });
      grid.appendChild(btn);
    });

    selectSign(defaultId);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
